import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { UILoader } from '@futrli/ui-components';
import {
  APIClients,
  ApiClientType,
  auth0Authenticator,
  IntegrationsAPIClient,
  deleteAuth0Cookies
} from '@futrli/shared-services';

import { storeSage50Data } from '../utils/sage-50';
import { signOut } from '../login/redux-utils/actions';
import { clearLocalStorageWithExceptions } from '@futrli/shared-services/string-utils/utils';

export const Sage50Trigger = () => {
  const { businessId: tempBusinessId } = useParams();
  const businessId = tempBusinessId || '';

  const dispatch = useDispatch();

  useEffect(() => {
    // Initialize API clients, it needs to be Auth0 since
    // users will be authenticated with SageID
    APIClients.setApiClient(ApiClientType.Auth0);
    IntegrationsAPIClient.setApiClient(ApiClientType.Auth0);

    // Terminates current user session
    const deleteSessionDataAndSignIn = async () => {
      await dispatch(signOut());
      sessionStorage.clear();
      clearLocalStorageWithExceptions();
      deleteAuth0Cookies();

      // Save business id to session storage
      storeSage50Data(businessId);

      // Immediately redirect user to SageId auth page
      auth0Authenticator.signIn();
    };

    deleteSessionDataAndSignIn();
  }, [businessId, dispatch]);

  return <UILoader isFull={true} />;
};
